import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import { Consultation } from '@/core/models/consultation.model'
import { MedicalActsSection } from '@/features/medical-acts/ui/MedicalActsSection'
import { PatientConsultations } from '@/features/patient/patient-consultations'

import { LiveTranscriptionSection } from '@/features/live-transcription'
import ConsultationForms from '@/pages/diagnostic/containers/ConsultationForms'
import Documents from '@/pages/diagnostic/containers/Documents'
import PatientInfo from '@/pages/diagnostic/containers/PatientInfo'

import { SidebarMenuItem } from '../model/useSidebarMenu'

type ContentProps = {
  consultation: Consultation
  consultationId: string
  selectedMenuItem: string
}

export function ConsultationLocalContent({ consultation, consultationId, selectedMenuItem }: ContentProps) {
  return (
    <Box sx={{ height: '100%', overflowY: 'auto', pt: '20px', pb: '20px' }}>
      <Container maxWidth="md">
        {selectedMenuItem === SidebarMenuItem.PATIENT_INFO && <PatientInfo consultationId={consultationId} />}
        {selectedMenuItem === SidebarMenuItem.DOCUMENTS && <Documents consultationId={consultationId} />}
        {selectedMenuItem === SidebarMenuItem.CONSULTATIONS && <PatientConsultations patientId={consultation.patient._id} />}
        {selectedMenuItem === SidebarMenuItem.TRANSCRIPTION && <LiveTranscriptionSection consultation={consultation} consultationId={consultationId} inPerson />}
        {selectedMenuItem === SidebarMenuItem.FORMS && <ConsultationForms consultationId={consultationId} />}
        {selectedMenuItem === SidebarMenuItem.MEDICAL_ACTS && <MedicalActsSection patientId={consultation.patient._id} consultationId={consultationId} />}
      </Container>
    </Box>
  )
}
